<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3 class="info-title">用户协议</h3>
				</div>
				<div class="info-content-xieyi" v-html="infoText">

                </div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
			infoText: '<h2>[特规通-特种设备标准规范智能服务平台]用户协议</h2><p>发布日期：2026年03月01日</p><p>生效日期：2026年03月01日</p><p>欢迎您使用[特规通-特种设备标准规范智能服务平台]（以下简称“本平台”）提供的各项服务。本协议是您（以下简称“用户”）与[量大（北京）信息科技研究院有限公司]（以下简称“运营方”）之间就使用本平台服务所订立的具有法律约束力的协议。</p><p>请您在注册、登录或使用本平台服务前，仔细阅读并充分理解本协议全部条款，特别是关于运营方免责、用户违约责任、知识产权、会员服务、在线交易、个人信息保护以及限制或免除责任的条款。若您不同意本协议任何内容，请勿注册、登录或使用本平台服务；您一旦注册、登录或使用本平台服务，即视为已充分理解并接受本协议全部条款，自愿与运营方建立服务合同关系。</p><p>运营方有权根据业务发展、法律法规更新、产品功能调整等情况对本协议进行修订。修订后的协议将通过本平台首页公告、弹窗提示或其他合理方式通知用户。若您在协议修订后继续使用本平台服务，即视为接受修订后的协议；若您不同意修订内容，应立即停止使用本平台服务。</p><p>一、服务内容与范围</p><p>1.1 本平台系面向特种设备标准规范相关场景提供信息服务、知识服务、交易服务及配套支持服务的平台，具体服务内容以平台实时展示的功能模块为准。</p><p>1.2 本平台提供的服务主要包括：</p><p>（1）内容与知识服务：内容浏览、内容查询、内容搜索、内容收藏、标准查询、智能AI问答、信息展示、信息发布、在线交流、数据存储等；</p><p>（2）交易与商品服务：正版标准法规商品展示、在线购买、订单管理、支付结算、物流跟踪、售后咨询等；</p><p>（3）会员与辅助服务：账户注册与管理、会员服务、实名认证、客服咨询、投诉处理、安全保障及其他配套服务。</p><p>1.3 运营方有权根据业务需求对服务内容、功能模块、服务方式、适用对象及平台规则进行调整，并通过合理方式向用户告知。</p><p>1.4 为保障服务质量、交易安全与平台秩序，运营方可根据用户类型、会员等级、使用场景、支付情况、账户状态等设置不同的服务权限、功能范围、使用次数、折扣政策或其他限制，具体以平台公示规则及页面展示为准。</p><p>二、会员类型、费用与交易规则</p><p>2.1 普通会员</p><p>2.1.1 本平台支持免费注册。用户完成注册后，即成为本平台普通会员。</p><p>2.1.2 普通会员本身不收取会员注册费用。普通会员可使用平台开放的基础功能，具体功能范围以平台实际展示为准。</p><p>2.1.3 普通会员可根据平台规则购买本平台销售的正版标准法规及其他相关商品，并按照平台届时公布的折扣政策享受相应优惠。折扣政策、适用品类、适用期限及适用条件以平台实时公示内容为准。</p><p>2.2 VIP会员</p><p>2.2.1 普通会员可根据平台规则自愿付费升级为VIP会员。VIP会员服务内容、权益范围、适用期限、定价标准及开通条件以平台届时公布的会员页面、活动页面或相关规则为准。</p><p>2.2.2 VIP会员费用实行公开定价，具体金额由本平台定期公布。用户应在支付前自行确认所购买的会员类型、期限、价格及权益内容。</p><p>2.2.3 本平台可能不定期开展VIP会员优惠活动。活动期间，用户可按照活动页面展示的规则、条件、价格及期限享受相应优惠。活动优惠不具有追溯适用效力，除活动规则另有说明外，历史订单不补差价、不退差价。</p><p>2.2.4 VIP会员服务一经购买并开通，原则上不支持退换、退款、转让、延期或折现。因法律法规另有规定，或用户存在特殊理由并经平台客服审核确认同意处理的除外。具体处理方式以平台客服最终审核结果及平台规则为准。</p><p>2.3 正版标准法规及商品购买</p><p>2.3.1 本平台可销售正版标准法规、电子资料、纸质资料及其他相关商品，具体商品信息、价格、库存、交付方式、使用限制及售后规则以商品详情页、公示规则及订单页面为准。</p><p>2.3.2 用户下单购买前，应认真核对商品名称、版本、规格、交付方式、价格、优惠内容及适用限制等信息。订单一经提交并支付成功，即视为用户认可相关交易内容。</p><p>2.3.3 因正版标准法规、电子资料等商品具有特殊性，已下载、已交付、已开通阅读权限或已激活的数字化商品，除法律法规另有规定或平台另有承诺外，原则上不支持无理由退货退款。</p><p>2.3.4 平台有权根据市场情况、合作方要求、版权要求、库存变化、政策变化或运营安排，对商品价格、折扣政策、销售方式及售后规则进行调整，具体以用户下单时页面展示内容为准。</p><p>三、用户注册与账户管理</p><p>3.1 注册资格</p><p>用户注册使用本平台服务，需具备完全民事行为能力。若您为无民事行为能力人或限制民事行为能力人，应在法定监护人陪同下阅读本协议，并在监护人同意后使用本平台服务。</p><p>3.2 注册信息</p><p>3.2.1 用户注册时应提供真实、准确、完整、合法、有效的信息，包括但不限于姓名、手机号码、身份证号码等；企业用户还应根据平台要求提供营业执照、联系人信息及其他必要资料。</p><p>3.2.2 用户应确保前述信息持续有效并及时更新。因用户提供的信息虚假、不准确、不完整或未及时更新导致无法使用服务、交易失败、遭受损失或给第三方造成损害的，由用户自行承担责任。</p><p>3.2.3 用户注册成功后，将获得唯一账户及密码。账户所有权归运营方所有，用户仅享有在本协议及平台规则范围内的使用权。未经运营方书面同意，用户不得将账户转让、出租、出借、出售、赠与或以其他方式许可第三方使用。</p><p>3.3 账号安全</p><p>3.3.1 用户应妥善保管账户密码、验证码及其他身份验证信息，并对账户下发生的一切操作行为承担责任。</p><p>3.3.2 如发现账户被盗用、异常登录、信息泄露或存在其他安全风险，用户应立即通知运营方，并及时采取修改密码、冻结账户等措施。运营方在收到通知后将根据平台规则协助处理，但对因用户未及时通知、保管不当或其他非运营方原因造成的损失不承担责任。</p><p>3.3.3 用户不得利用账户从事任何违法违规行为，不得损害本平台、其他用户或第三方的合法权益。否则，运营方有权依据本协议及平台规则采取相应措施。</p><p>3.4 账户注销</p><p>用户可根据平台规定流程申请注销账户。申请注销前，用户应确保账户内不存在未完成交易、未结清款项、未履行完毕的义务或其他争议事项。账户注销后，运营方将依据法律法规及《隐私政策》处理相关信息，不再继续提供相关服务；但注销前已经形成的权利义务关系不受影响。</p><p>3.5 长期未使用账户处理</p><p>对于连续12个月及以上未登录，且无绑定有效联系方式、无未完成交易或其他待处理事项的账户，运营方有权根据平台运营需要进行清理，包括但不限于冻结账户、限制登录或删除账户信息等。</p><p>四、用户权利与义务</p><p>4.1 用户权利</p><p>4.1.1 依法使用本平台提供的服务，并获取与服务相关的信息；</p><p>4.1.2 对本平台服务提出意见、建议，监督运营方服务质量；</p><p>4.1.3 在符合本协议及平台规则的前提下，自主管理账户信息、订单信息及相关内容；</p><p>4.1.4 当合法权益受到侵害时，可根据本协议、平台规则或法律规定向运营方投诉或主张权利。</p><p>4.2 用户义务</p><p>4.2.1 遵守国家法律法规、公序良俗以及本协议和平台规则，不得利用本平台从事任何违法违规活动，包括但不限于：</p><p>发布、传播含有违法、淫秽、暴力、恐怖、侮辱、诽谤、谣言、歧视等内容的信息；</p><p>侵犯他人知识产权、名誉权、隐私权、肖像权、商业秘密等合法权益；</p><p>实施欺诈、虚假交易、洗钱、非法经营或其他违法活动；</p><p>恶意攻击、入侵、破坏本平台系统或窃取、篡改平台数据及用户数据；</p><p>使用外挂、脚本、爬虫或其他非法技术手段扰乱平台秩序、获取不当利益；</p><p>其他违反法律法规或损害平台、第三方合法权益的行为。</p><p>4.2.2 妥善保管账户信息，及时更新资料，确保注册信息和交易信息真实、准确、完整、有效；</p><p>4.2.3 尊重其他用户及第三方合法权益，不得实施骚扰、诋毁、侵害等行为；</p><p>4.2.4 不得未经运营方或相关权利人许可，复制、传播、抓取、改编、翻译、汇编、展示、出售或以其他方式非法利用本平台内容、商品信息、数据库、页面设计、技术成果或服务成果；</p><p>4.2.5 按照规定支付相关费用，按时履行订单交易义务及其他合同义务；</p><p>4.2.6 配合运营方基于合法合规、安全管理、投诉处理、争议解决等需要开展的核验、检查或调查，并提供必要证明材料；</p><p>4.2.7 承担因使用本平台服务而产生的全部责任，包括但不限于因自身行为引发的法律责任、赔偿责任及其他不利后果。</p><p>五、运营方权利与义务</p><p>5.1 运营方权利</p><p>5.1.1 按照本协议及平台规则提供服务，并制定、修改、解释平台规则；</p><p>5.1.2 对用户使用服务的行为进行监督、审核、管理；如发现用户违反本协议、平台规则或法律法规，有权采取警告、删除内容、限制功能、限制交易、冻结账户、终止服务等措施；</p><p>5.1.3 为保障服务安全、交易履行、产品运营及合规要求，在符合法律法规及《隐私政策》的前提下收集、使用、存储用户必要信息；</p><p>5.1.4 因技术升级、系统维护、版权要求、合作安排、合规要求或运营调整等原因，有权暂停、中断、限制或终止部分或全部服务，并通过合理方式通知用户；紧急情况除外；</p><p>5.1.5 对用户使用服务过程中存在的违法违规行为，有权依法向有关部门举报并配合调查；</p><p>5.1.6 在法律法规允许范围内，有权对平台服务开展推广、合作、整合、运营优化等行为。</p><p>5.2 运营方义务</p><p>5.2.1 按照本协议约定提供稳定、安全、持续改进的服务，并建立必要的技术保障和安全管理机制；</p><p>5.2.2 遵守个人信息保护相关法律法规，妥善保管用户个人信息，不得非法泄露、篡改、毁损、出售或非法向第三方提供用户信息；</p><p>5.2.3 建立投诉处理机制，及时受理用户投诉、建议，并在合理期限内处理或反馈；</p><p>5.2.4 向用户公示与服务、会员、商品、交易、支付、售后等相关的说明信息及平台规则；</p><p>5.2.5 不得利用平台服务从事违法违规活动，不得非法侵害用户合法权益；</p><p>5.2.6 因自身技术故障、系统漏洞或其他过错导致用户遭受直接损失的，应根据过错程度承担相应责任；但因不可抗力、用户自身原因或第三方原因造成的，不承担责任。</p><p>六、知识产权</p><p>6.1 本平台的软件、代码、数据库、页面设计、界面元素、LOGO、商标、文字、图片、音频、视频及其他内容的知识产权，均归运营方或相关权利人所有，并受《中华人民共和国著作权法》《中华人民共和国商标法》及其他法律法规保护。</p><p>6.2 未经运营方或相关权利人书面许可，用户不得以任何方式对前述内容进行复制、传播、展示、改编、翻译、汇编、反向工程、反编译、出租、出售或其他侵犯知识产权的行为。</p><p>6.3 用户在使用本平台服务过程中上传、发布的内容，其知识产权归用户或相关权利人所有；但用户应保证其对相关内容享有合法权利或已取得充分授权，不得侵犯第三方合法权益。</p><p>6.4 用户同意授予运营方一项非独占、可转授权、可再许可、全球范围内的免费使用许可，允许运营方在提供服务、展示内容、推广平台、处理投诉、合规审核及其他合理必要范围内使用、复制、传播、展示用户上传、发布的内容。该许可在用户注销账户后，对注销前已经合法使用的内容继续有效。</p><p>七、隐私保护</p><p>7.1 运营方重视用户个人信息保护，并将按照《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》《中华人民共和国数据安全法》及其他适用法律法规和本平台《隐私政策》的规定收集、使用、存储、共享及保护用户个人信息。</p><p>7.2 《隐私政策》是本协议的重要组成部分，与本协议具有同等法律效力。用户应同时仔细阅读并遵守《隐私政策》。</p><p>八、免责条款</p><p>8.1 因不可抗力，包括但不限于自然灾害、战争、政府行为、政策调整、通信故障、网络中断、供电故障等导致本平台无法正常提供服务的，运营方不承担责任，但将尽合理努力减少用户损失。</p><p>8.2 因第三方原因，包括但不限于网络服务提供商故障、支付机构故障、物流服务异常、黑客攻击、第三方软件漏洞、版权方限制等导致服务中断、商品下架、交易异常或用户损失的，运营方不承担直接责任，但可在合理范围内协助用户协调处理。</p><p>8.3 本平台部分服务、数据、内容或商品信息可能来源于第三方。运营方对第三方提供内容仅在合理范围内进行形式审查，不对其准确性、完整性、合法性、时效性作出明示或默示保证。用户使用第三方服务或内容所产生的风险由用户自行承担。</p><p>8.4 用户因违反本协议、平台规则或法律法规而导致自身或第三方损失的，由用户自行承担责任；因此给运营方造成损失的，运营方有权向用户追偿。</p><p>8.5 对于本平台提供的免费服务，运营方在法律允许范围内不作任何明示或暗示担保，不保证服务绝对连续、无瑕疵、无故障、完全适合用户特定需求。用户应根据自身需要谨慎判断和使用。</p><p>8.6 本平台提供的智能AI问答、检索、推荐、摘要等功能，仅作为信息服务和辅助工具，不构成法律意见、技术鉴定意见、认证结论、检验检测结论、工程设计意见、强制性合规承诺或其他专业结论。用户应结合实际情况进行审慎判断，并自行承担基于相关输出所作决策的后果。</p><p>九、违约责任</p><p>9.1 用户违约责任</p><p>用户违反本协议、平台规则或相关法律法规的，运营方有权根据违约情节采取警告、删除内容、限制功能、限制交易、取消优惠、冻结账户、终止服务等措施；给运营方或第三方造成损失的，用户应承担全部赔偿责任，包括但不限于直接损失、可得利益损失、律师费、诉讼费、保全费、鉴定费、公证费及其他维权合理费用。构成违法犯罪的，运营方有权移交有关部门处理。</p><p>9.2 运营方违约责任</p><p>运营方违反本协议约定，导致用户遭受直接损失的，应根据其过错程度承担相应责任；但赔偿金额以用户就相关服务在本平台实际支付的服务费用为上限，法律法规另有强制性规定的除外。对于免费服务，除法律法规另有规定外，运营方不承担赔偿责任。</p><p>十、协议的生效、变更与终止</p><p>10.1 本协议自用户注册、登录或实际使用本平台服务之日起生效，对双方具有法律约束力。</p><p>10.2 运营方对本协议进行修订的，按照本协议前述约定执行。修订后的协议一经公布并在公示期届满后生效；用户在修订生效后继续使用本平台服务的，视为接受修订后的协议。</p><p>10.3 有下列情形之一的，本协议终止：</p><p>（1）用户注销账户并完成全部未了结义务；</p><p>（2）运营方依法或依约终止全部平台服务；</p><p>（3）双方协商一致终止；</p><p>（4）因法律法规规定或司法机关、行政机关要求导致协议终止；</p><p>（5）其他依据本协议或平台规则应当终止的情形。</p><p>10.4 协议终止后，双方在本协议项下已产生但未履行完毕的权利义务仍应继续履行；关于知识产权、隐私保护、保密、免责、违约责任、争议解决等具有持续性的条款，不因协议终止而失效。</p><p>十一、争议解决</p><p>11.1 因本协议引起的或与本协议有关的任何争议，双方应先友好协商解决。</p><p>11.2 协商不成的，任何一方均有权向运营方所在地有管辖权的人民法院提起诉讼。</p><p>十二、其他条款</p><p>12.1 本协议的订立、效力、履行、解释及争议解决，均适用中华人民共和国法律法规。</p><p>12.2 本协议未尽事宜，由双方另行协商或按照平台另行发布的补充协议、平台规则执行。补充协议、平台规则与本协议构成统一整体，具有同等法律效力；如相关约定不一致，以具体适用场景下最新有效且明确公示的规则为准，但法律法规另有规定的除外。</p><p>12.3 本协议各条款标题仅为阅读方便而设，不影响条款的解释和法律效力。</p><p>12.4 运营方联系方式为：18911620150、service@teguitong.com、北京市朝阳区胜古中路2号院8号楼企发大厦817室。用户可通过前述方式进行咨询、投诉或反馈。</p><p>12.5 本协议自2026年03月01日起发布并生效。</p><p>[量大（北京）信息科技研究院有限公司]</p><p>[2026年03月01日]</p>'
		};
	}
};
</script>

<style lang="less" scoped>
/deep/ .info-content-xieyi ul {
	list-style: none !important;
    padding: 0;
}

/deep/ .info-content-xieyi li {
	list-style: none !important;
}
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	// color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);

	.info-title {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
    
}



.info-item {
	margin-bottom: 20px;
}

.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;

	.topbox {
		color: #94a3b8;

		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content-xieyi p {
	line-height: 30px;
}
.info-content-xieyi {
	// text-indent: 2em;
	padding: 0 30px;
}

.info-content-xieyi ul {
	// list-style: none !important;
    // padding: 0;
}

.info-content-xieyi li {
	// list-style: none !important;
}

.info-content-xieyi p {
	margin: 0;
}

.info-content-xieyi h5 {
	color: #0f172a;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	margin-top: 10px;
}

.info-content-xieyi h6 {
	color: #0f172a;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	position: relative;
}

.info-content-xieyi h6:before {
	content: ' ';
	display: inline-block;
	width: 5px;
	height: 5px;
	background: #155dfc;
	border-radius: 50%;
	margin-right: 10px;
	position: absolute;
	top: 16px;
	left: 18px;
}

.info-box {
	padding-bottom: 30px;
}
</style>